import styled from '@emotion/styled';
import Slider from 'react-slick';
import {colors} from 'ui/config';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: colors.greyLight,
});

export const Slides = styled(Slider)({
  width: '100vw',
});
